import { Grid, withStyles } from '@material-ui/core';

import { bigRadius } from '~/src/dash/utils/material-dashboard-react';

export const ModelPrimaryContainer = withStyles({
  root: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #CBCBCB',
    borderRadius: bigRadius,
    opacity: '1',
    paddingLeft: '2%',
    paddingRight: '2%',
    marginBottom: '25px',
    minHeight: '50px',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
})(Grid);
